import React from "react";

import { CellContentRoot } from "../../../../../../../../../../../../components/LightTable";

const CompaniesCellContent: React.FC<CompaniesCellContent.Props> = ({
	item,
}) => {
	const content = item.companies ?? "_companies";

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace CompaniesCellContent {
	interface Props {
		item: any;
	}
}

export default CompaniesCellContent;
